import React from 'react';
import Stack from "../ui/Stack";
import Title from "../ui/Title";

const SubHeader = ({children, title, sticky= false}) => {
    return (
        <>
            <div className={`d-flex justify-content-between align-items-end mb-3${sticky ? " subheader-sticky": ""}`}>
                <div className="me-auto">
                    <Title className="mb-0 fs-4">{title}</Title>
                </div>
                <Stack className="column-gap-3">
                    {children}
                </Stack>
            </div>
        </>
    )
};

export default SubHeader;
